import type { MouseEvent } from 'react';

import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fromCamelCaseToWords, triggerGtmEvent } from '../misc/functions';
import { gtmEvents } from '../misc/gtm.constants';
import { ASC, DESC, sortUpdated } from '../features/table/table.slice';
import type { SortState } from '../types';

interface ColumnTitleProps {
  column: string;
  text?: string;
}

export function ColumnTitle({ column, text = '' }: ColumnTitleProps) {
  const dispatch = useAppDispatch();
  const sort = useAppSelector((state) => state.table.sort);
  let direction: string | undefined;
  if (sort.column === column && sort.direction !== '') {
    direction = sort.direction;
  }

  function onClick(event: MouseEvent<HTMLTableCellElement>) {
    const sortColumn = event.currentTarget.dataset.sortColumn;
    const sortDirection = event.currentTarget.dataset.sortDirection;
    const newSort: Partial<SortState> = {};
    const eventInfo: { label?: string; method?: string } = {
      label: sortColumn,
    };
    if (sortColumn !== sort.column) {
      newSort.column = sortColumn;
    }
    if (sortDirection === undefined || sortDirection === DESC) {
      newSort.direction = ASC;
      eventInfo.method = ASC;
    } else {
      newSort.direction = DESC;
      eventInfo.method = DESC;
    }
    dispatch(sortUpdated(newSort));
    triggerGtmEvent(gtmEvents.tableSort, {
      ...eventInfo,
    });
  }

  return (
    <th
      data-sort-column={column}
      data-sort-direction={direction}
      data-qa={column}
      onClick={onClick}
    >
      {fromCamelCaseToWords(text)}
    </th>
  );
}
